package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun StatsView(
    modifier: Modifier = Modifier,
    title: String,
    subtitle: String,
    value: Int? = 0,
    content: @Composable ColumnScope.() -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.background(sitePalette.background)
            .boxShadow(
                color = sitePalette.onBackground.toRgb().copy(alpha = 8),
                blurRadius = 12.px
            )
            .fillMaxWidth()
            .height(500.px)
            .borderRadius(4.px)
    ) {
        Row(
            modifier = Modifier.height(80.px)
                .fillMaxWidth()
                .background(sitePalette.nearBackground)
                .padding(topBottom = 12.px, leftRight = 24.px)
                .borderBottom(1.px, style = LineStyle.Solid, color = sitePalette.onBackgroundLight),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier.fillMaxWidth()
                    .maxHeight(100.percent)
                    .overflow(Overflow.Hidden)
            ) {
                SpanText(
                    title, modifier = Modifier.fontSize(18.px)
                        .margin(bottom = 4.px)
                )
                SpanText(
                    subtitle, modifier = Modifier.fontSize(14.px)
                        .color(sitePalette.onBackgroundLight)
                )
            }
            Spacer()
            SpanText("${value ?: 0}", modifier = Modifier.fontSize(FontSize.Larger))
        }
        Column(modifier = Modifier.weight(1).fillMaxWidth()) {
            content()
        }
    }
}